import { makeStyles } from '@material-ui/styles';

export default makeStyles(() => ({
    root: {},
    optionLabel: {},
    deleteIcon: {},
    autoTextButton: {},
    buttonWithOptions: {
        '& .options-popper': {
            '& div': {
                maxHeight: '95vh',
            },
        },
    },
    autoTextButtonContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-end',
        zIndex: 3,
    },
}));
